import { Badge } from '../ui';
import type { VersionStatus } from '../../api/datasets';

const PRESENTATION: Record<
  VersionStatus,
  { tone: 'neutral' | 'brand' | 'success' | 'danger'; label: string }
> = {
  PENDING: { tone: 'neutral', label: '⏳ Queued' },
  PROCESSING: { tone: 'brand', label: '☕ Brewing' },
  READY: { tone: 'success', label: '✅ Ready' },
  FAILED: { tone: 'danger', label: '⚠️ Failed' },
};

/** Ingestion status. Icon plus words — never colour alone (section 12). */
export function VersionStatusBadge({ status }: { status: VersionStatus }) {
  const { tone, label } = PRESENTATION[status];

  return (
    <Badge tone={tone} srPrefix="Status">
      {label}
    </Badge>
  );
}
